var map = {
	"./symbol_0.png": 88917,
	"./symbol_1.png": 77292,
	"./symbol_10.png": 73622,
	"./symbol_11.png": 51711,
	"./symbol_12.png": 38148,
	"./symbol_2.png": 44327,
	"./symbol_3.png": 68542,
	"./symbol_4.png": 13105,
	"./symbol_5.png": 64712,
	"./symbol_6.png": 26691,
	"./symbol_7.png": 36858,
	"./symbol_8.png": 89741,
	"./symbol_9.png": 26500
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21544;